import React from 'react';
import { Content } from 'reactjs-admin-lte';
import JobIssueForm from './JobIssueForm';


const JobSplitIssue = (props) => {  
  return (
    <Content.Body>
      <JobIssueForm {...props} />
    </Content.Body>
  );
}

export default JobSplitIssue;
